import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#43B4D4",
      d: "M0 4a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F8F9FB",
      d: "M7.506 15.833q-.495.315-1 .036A.92.92 0 0 1 6 15.01V4.99q0-.58.506-.86.505-.278 1 .037l8.05 5.01A.93.93 0 0 1 16 10q0 .533-.444.823z"
    }, null, -1)
  ])))
}
export default { render: render }